
export enum LegalEntityDocumentTypeName {

  // Copy of any certificate of name change issued by the REQ
  AnyCertNameChByReq = 'AnyCertNameChByReq',
  // Certified copy of any amending declaration filed with the REQ
  CertAmendDeclWithReq = 'CertAmendDeclWithReq',
  // Copy of the certificate of amalgamation issued by the REQ
  CertAmalgByReq = 'CertAmalgByReq',
  // Copy of the certificate of amalgamation issued by Innovation, Science and Economic Development Canada
  CertAmalgByIsde = 'CertAmalgByIsde',
  // Certificate of name change issued by Corporations Canada
  CertNameChByCorpsCan = 'CertNameChByCorpsCan',
  // Declaration filed with the REQ attesting to the name change
  DeclAttestNameChWithReq = 'DeclAttestNameChWithReq',
  // Copy of the declaration of short-form merger filed with the REQ
  DeclShortFormMergerWithReq = 'DeclShortFormMergerWithReq',
  // Original of the form for an agreement between a dentist transferring records and the dentist receiving transferred records
  OrigFrmAgreemtDentistRecsXfer = 'OrigFrmAgreemtDentistRecsXfer',
  // Other documentation
  Other = 'Other',
  // Confirmation of acceptance by representative
  ConfirmationAcceptanceRepresentative = 'ConfirmationAcceptanceRepresentative',
  // État des renseignement d'une société au Registre des Entreprises
  CompanyInformationStatementAtREQ = 'CompanyInformationStatementAtREQ',
}
